import {
  FILTERS_PAGINATION_PAGE_CHANGE_STARTED,
  FILTERS_PAGINATION_PAGE_CHANGE_FINISHED,
} from 'shared/actions/pagination';
import { IAppState, TActions } from 'shared/common/state';
import { defaultHideOfferState } from 'shared/serp/state/hide_offer';

export function paginationReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case FILTERS_PAGINATION_PAGE_CHANGE_STARTED:
      return {
        ...state,
        isFetching: true,
      };

    case FILTERS_PAGINATION_PAGE_CHANGE_FINISHED:
      return {
        ...state,
        results: {
          ...state.results,
          queryString: action.data.queryString,
          jsonQuery: action.data.jsonQuery,
          offers: action.data.offersSerialized,
          aggregatedOffers: action.data.aggregatedCount,
          totalOffers: action.data.offerCount,
          seo: action.data.seoData,
          fullUrl: action.data.fullUrl,
          paginationUrls: action.paginationUrls,
          suggestions: action.data.suggestOffersSerializedList || null,
          suggestionsQuery: action.data.suggestionsQuery,
        },
        breadcrumbs: action.commercialBreadcrumbs?.breadcrumbs ?? action.data.breadcrumbs,
        isFetching: false,
        hideOffer: defaultHideOfferState,
        mlRankingGuid: action.data.mlRankingGuid || null,
        mlRankingModelVersion: action.data.mlRankingModelVersion || null,
        searchRequestId: action.data.searchRequestId,
        newbuildingPromoBuilderOffers: action.data.specialPromoBuilderOffers || null,
        specialPromoSecondaryOffers: action.data.specialPromoSecondaryOffers || null,
      };

    default:
      return state;
  }
}
